"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var StyledLoader_1 = require("./StyledLoader");
var LoaderInner = function (props) { return (react_1.default.createElement(StyledLoader_1.Wrapper, tslib_1.__assign({}, props),
    react_1.default.createElement("div", null),
    react_1.default.createElement("div", null),
    react_1.default.createElement("div", null),
    react_1.default.createElement("div", null),
    react_1.default.createElement("div", null),
    react_1.default.createElement("div", null),
    react_1.default.createElement("div", null),
    react_1.default.createElement("div", null))); };
/** @component */
exports.Loader = recompose_1.compose(styled_components_1.withTheme)(LoaderInner);
//# sourceMappingURL=Loader.js.map